import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './tooltip.scss';

const Tooltip = ({children, position}) => (
  <div className={classnames(styles.tooltip, styles[`${position}`])}>
    {children}
  </div>
);

Tooltip.propTypes = {
  position: PropTypes.string,
};

export { Tooltip };


// WEBPACK FOOTER //
// ./src/elements/tooltip/tooltip.js